var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-layout-top',{attrs:{"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"slider-modal"},[_c('invoice-preview',{attrs:{"data":_vm.invoice,"logo-url":_vm.logoUrl},on:{"closePanel":function($event){_vm.closePanel()},"save":function($event){_vm.save()}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c528168","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/InvoicePreviewModal.vue
// module id = null
// module chunks = 